// stores/auth.js
import { defineStore } from 'pinia'
import { ref ,computed} from 'vue'
import { api } from '../utils/request'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('token'))
const getUserFromStorage = () => {
    try {
      const userStr = localStorage.getItem('user')
      // 增强检查条件，排除 "undefined" 字符串
      if (userStr && userStr !== 'null' && userStr !== 'undefined') {
        return JSON.parse(userStr)
      }
      return null
    } catch (error) {
      console.warn('解析用户信息时出错:', error)
      return null
    }
  }
  
  const user = ref(getUserFromStorage())
  const isLoggedIn = ref(!!token.value)
  const isAdmin = computed(() => user.value && user.value.username === 'admin')
  
  const login = async (username, password) => {
  try {
    const response = await api.post('/api/login', { username, password })
    token.value = response.access_token
    user.value = response.user
    isLoggedIn.value = true
    
    localStorage.setItem('token', token.value)
    localStorage.setItem('user', JSON.stringify(user.value))
    
    return { success: true }
  } catch (error) {
    // 处理登录错误
    let errorMessage = '登录失败'
    
    // 根据错误状态码提供具体错误信息
    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMessage = '用户名或密码错误'
          break
        case 403:
          errorMessage = '账户已被禁用'
          break
        case 500:
          errorMessage = '服务器内部错误'
          break
        default:
          // 即使后端不返回详细信息，我们也提供一个通用的错误提示
          errorMessage = error.response.data?.detail || error.response.data?.message || '登录失败'
      }
    } else if (error.request) {
      errorMessage = '网络连接错误'
    }
    
    return { success: false, message: errorMessage }
  }
}
  
  const logout = () => {
    token.value = null
    user.value = null
    isLoggedIn.value = false
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  return {
    token,
    user,
    isLoggedIn,
    isAdmin,
    login,
    logout
  }
})
export const useAppStore = defineStore('app', {
  state: () => ({
    sidebarCollapsed: false,
    mobileSidebarOpen: false,
    
  }),
  
  actions: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    
    toggleMobileSidebar() {
      this.mobileSidebarOpen = !this.mobileSidebarOpen
    },
    
    setActiveMenu(menu) {
      this.activeMenu = menu
    },
    
    closeMobileSidebar() {
      this.mobileSidebarOpen = false
    }
  },
  
  getters: {
    isSidebarCollapsed: (state) => state.sidebarCollapsed,
    isMobileSidebarOpen: (state) => state.mobileSidebarOpen,
    getActiveMenu: (state) => state.activeMenu
  }
})